<input type="search" placeholder="Søg i indbo" [(ngModel)]="searchText" (ngModelChange)="search()" name="search" />
<ul class="effects">
    <li *ngFor="let e of effects" (click)="itemClick(e)" [class.added]="e.addedToCase">
        <div class="name">{{e.itemText}}</div>
        <div class="price">{{e.itemPrice | currency:'DKK':true}}</div>
        <div class="date">{{e.itemAcquisitionDate.toString()| moment:'DD-MM-YYYY'}}</div>
    </li>
</ul>